import { Box, Button, Divider, Typography } from "@mui/material"
// import React from "react"
import React, { useContext } from "react"
import { JobTile } from "../JobTile/JobTile"
import { EJobStatus, IJob, IJobListing } from "../../entities/job/interface"
import ShiftContext from "../../contexts/ShiftContext"
import { useTranslation } from "react-i18next"
import { CenterCircular } from "../Loading"
import { useJobContext } from "../../contexts/JobContext"
import { jobInPickupPhase, useBulkUpdateStatusHook } from "../../entities/job/helper"
import { matchJobsWithStops } from "../../utils/job"
import { hiddenScrollbar } from "../../styles/theme"

interface DestinationStop {
    jobId: string
    type: string
    status: string
}

const Consecutive = () => {
    //translation
    const { t } = useTranslation()
    const [selectedJobs, setSelectedJobs] = React.useState<number[]>([])
    const [loading, setLoading] = React.useState<boolean>(false)
    const shiftContext = useContext(ShiftContext)
    const { handleBulkJobsUpdate } = useBulkUpdateStatusHook()
    const { currentJobs, setIsConsecutive, currentStops, currentDestinationIndex, groupId, setCurrentJobStatus } =
        useJobContext()

    const updatedGroupArray: IJob[] | null = []

    const capacityArray = [
        {
            id: 1,
            name: "Vehicle Capacity",
            value: shiftContext?.vehicle ? `${shiftContext?.vehicle?.capacity}T` : "",
        },
        {
            id: 2,
            name: "Total Weight",
            value: "",
        },
        {
            id: 3,
            name: "Remaining Capacity",
            value: "",
        },
    ]

    const handleTileClick = (index: number) => {
        let updatedSelectedJobs: number[] = []

        if (selectedJobs.includes(index)) {
            updatedSelectedJobs = selectedJobs.filter((item) => item !== index) // Deselect the item if already selected
        } else {
            updatedSelectedJobs = [...selectedJobs, index] // Select the clicked item
        }

        // Update state with the updated selected items
        setSelectedJobs(updatedSelectedJobs)
    }

    const handleStartJobs = async () => {
        setLoading(true)

        if (shiftContext && shiftContext.stops) {
            const matchedStopsGroups = matchJobsWithStops(updatedGroupArray, currentStops)

            if (groupId && shiftContext?.stops.hasOwnProperty(groupId)) {
                if (
                    Array.isArray(shiftContext?.stops[groupId].destinationStops) &&
                    currentDestinationIndex < shiftContext?.stops[groupId].destinationStops.length
                ) {
                    shiftContext?.stops[groupId].destinationStops.splice(
                        currentDestinationIndex,
                        1,
                        ...matchedStopsGroups
                    )
                } else {
                    console.error("Destination stops are not in an array format.")
                }
            } else {
                console.error("Group ID not found in shift context stops.")
            }

            const jobIds = updatedGroupArray.filter((job) => !job.isJobCompleted).map((job) => job._id)
            if (jobIds.length === 0) return
            const isJobInPickupPhase =
                jobInPickupPhase(updatedGroupArray[0].jobStatus) && updatedGroupArray[0].jobStatus !== EJobStatus.loaded
            const jobStatus = isJobInPickupPhase ? EJobStatus.onRouteToPickup : EJobStatus.onRouteToDelivery
            // Update all jobs to the next status
            handleBulkJobsUpdate(jobIds, jobStatus)

            // Set the selected job in the context
            setCurrentJobStatus(jobStatus)

            shiftContext?.setStops(shiftContext?.stops)
            const destinationStops = shiftContext?.stops[groupId].destinationStops
            window.sessionStorage.setItem("destinationStops", JSON.stringify(destinationStops))
        }
        window.sessionStorage.setItem("screens", JSON.stringify({ consecutive: "false", roadMap: "false" }))
        setIsConsecutive(false)
        setLoading(false)
    }

    if (!currentJobs || loading) {
        return <CenterCircular />
    }
    const isJobInPickupPhase =
        jobInPickupPhase(currentJobs[0]?.jobStatus) && currentJobs[0]?.jobStatus !== EJobStatus.loaded

    const { title, heading, subHeading } = isJobInPickupPhase
        ? { title: "Pickup", heading: "Pickups", subHeading: "Pickup" }
        : { title: "Delivery", heading: "Deliveries", subHeading: "Delivery" }

    return (
        <Box
            width={"90%"}
            maxWidth={700}
            display="flex"
            flexDirection="column"
            bgcolor={"secondary.light"}
            position={"absolute"}
            borderRadius={6}
            alignItems={"center"}
            justifyContent={"space-between"}
            mt={"10%"}
            paddingY={5}
            height={"80vh"}
            sx={hiddenScrollbar}
        >
            <Box
                display="flex"
                alignItems={"center"}
                flexDirection="column"
                borderRadius={6}
                width={"100%"}
                sx={hiddenScrollbar}
            >
                <Typography variant="h4" color="white" fontWeight={"bold"} sx={{ marginBottom: 3 }}>
                    Consecutive {title}
                </Typography>
                <Divider
                    sx={{
                        borderColor: "white",
                        opacity: 0.5,
                        borderWidth: 1,
                        borderStyle: "dashed",
                        width: "90%",
                        marginBottom: 1,
                    }}
                />
                <Box paddingX={1} width={"100%"} display="flex" alignItems={"center"} flexDirection="column">
                    <Box paddingX={1} display={"flex"} flexDirection={"column"} alignItems={"center"}>
                        <Typography variant="h6" color="white">
                            There are some more {heading} for this location. Please select Jobs which you want to{" "}
                            {subHeading}.
                        </Typography>
                    </Box>
                    <Box
                        display={"flex"}
                        justifyContent={"space-between"}
                        marginX={10}
                        flexDirection={"column"}
                        width={"90%"}
                        marginY={2}
                    >
                        {capacityArray?.map((item) => {
                            return (
                                <Typography variant="h6" color="white" key={item.id}>
                                    {item.name} : {item.value}
                                </Typography>
                            )
                        })}
                    </Box>
                    <Divider
                        sx={{
                            borderColor: "white",
                            opacity: 0.5,
                            borderWidth: 1,
                            borderStyle: "dashed",
                            width: "90%",
                            marginBottom: 1,
                            marginTop: 1,
                            alignSelf: "center",
                            marginX: "auto",
                        }}
                    />

                    <Box width={"90%"} mt={3} sx={{ ...hiddenScrollbar, overflowY: "hidden" }}>
                        {currentJobs?.map((item: IJob, index: number) => {
                            const isSelected = selectedJobs?.includes(index)
                            if (isSelected) {
                                updatedGroupArray.push(item)
                            }

                            return (
                                <JobTile
                                    key={index}
                                    job={item as IJobListing}
                                    index={""}
                                    handleJobStarted={function (job: IJob): Promise<void> {
                                        throw new Error("Function not implemented.")
                                    }}
                                    swipeThreshold={0}
                                    avatarColor={isSelected ? "#00A300" : "white"}
                                    onAvatarClick={() => {
                                        handleTileClick(index)
                                    }}
                                    content={"✓"}
                                    isCheckAvatar={true}
                                    isSwipe={false}
                                />
                            )
                        })}
                    </Box>
                    <Box width={"100%"} display={"flex"} justifyContent={"center"}>
                        <Button
                            onClick={() => {
                                handleStartJobs()
                            }}
                            variant={"outlined"}
                            disabled={selectedJobs.length === 0}
                            sx={{
                                backgroundColor: "transparent",
                                color: "white",
                                width: "60%",
                                marginTop: 3,
                                borderColor: "white",
                                paddingY: "14px",
                                borderWidth: 2,
                                "&:hover": {
                                    borderColor: "white",
                                    borderWidth: 2,
                                },
                                borderRadius: 3,
                            }}
                        >
                            {t("start Job")}
                        </Button>
                    </Box>
                </Box>
            </Box>
        </Box>
    )
}

export default Consecutive
